module.exports = __webpack_public_path__ + "img/codePic.cae46ae8.png";